// Feature keys granted per user via the "features" list in localStorage
// (SessionStorageService.getFeatureKeys()). Each feature/module that gates
// UI behind a feature key adds its key here, under this single export,
// rather than as its own separate top-level constant.
export const ModuleFeatureKey = {
  DELIVERABLE_CREATE: "DELIVERABLE_CREATE",
  COA_CREATE: "COA_CREATE",
  TEMPLATE_CREATE: "RULE_ENGINE_TEMPLATE_CREATE",
  RULE_ENGINE_TEMPLATE_UPLOAD: "RULE_ENGINE_TEMPLATE_UPLOAD",
  RULE_ENGINE_TEMPLATE_EXPORT: "RULE_ENGINE_TEMPLATE_EXPORT",
  DELIVERABLE_VIEW: "DELIVERABLE_VIEW",
  TAX_FORM_ADMIN: "TAX_FORM_ADMIN",
  USER_MANAGEMENT_INVITE: "UserManagement_Invite",
  EXTERNAL_K1_UPLOAD: "EXTERNAL_K1_UPLOAD",
  // K1/K2/K3 engine and admin routes (replaces TAX_FORM_ADMIN there; TAX_FORM_ADMIN now only gates tax form and tax form line management).
  K1_GENERATE: "K1_GENERATE",
  USER_MANAGEMENT_INVITE_USER: "USER_MANAGEMENT_INVITE_USER",
  USER_MANAGEMENT_DEACTIVATE_USER: "USER_MANAGEMENT_DEACTIVATE_USER",
  USER_GROUP_LIST: "USER_GROUP_LIST",
  USER_GROUP_CREATE: "USER_GROUP_CREATE",
} as const;
